export default __webpack_public_path__ + "static/media/back.0992141f.svg";